import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class SocketCorporateService {
  private socket: Socket;
  constructor() {
    var accessToken = sessionStorage.getItem('accessToken');
    this.socket = io(`${environment.reportApiUrl}/corporate`, {
      extraHeaders: {
        Authorization: 'Bearer ' + accessToken,
      },
    });
  }
  // Listen to events
  listen(eventName: string): Observable<any> {
    if (this.socket.disconnected) {
      this.socket.connect();
    }
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }
  disconnect() {
    this.socket.disconnect();
  }
}